import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetchSellerDirectory } from '../../util/api';
import { storableError } from '../../util/errors';

export const fetchDirectoryThunk = createAsyncThunk(
  'SellerDirectoryPage/fetchDirectory',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchSellerDirectory();
      return Array.isArray(data?.sellers) ? data.sellers : [];
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);

const slice = createSlice({
  name: 'SellerDirectoryPage',
  initialState: { sellers: [], fetchInProgress: false, fetchError: null },
  extraReducers: builder => {
    builder
      .addCase(fetchDirectoryThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchError = null;
      })
      .addCase(fetchDirectoryThunk.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.sellers = action.payload;
      })
      .addCase(fetchDirectoryThunk.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchError = action.payload;
      });
  },
});

export default slice.reducer;

export const loadData = () => dispatch => dispatch(fetchDirectoryThunk());
